module.exports = {
      id: "gift-list-edit-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#gift-list-edit",
      toString: function () {
        return this.url;
      }
    }